export default "__VITE_ASSET__BxACSblr__"